export const getStyles = () => ({
  badgeContainer: {
    background: '#DFF6DD',
    border: '1px solid #107C10',
    borderRadius: '4px',
    width: 'fit-content',
    color: '#107C10',
    padding: '4px 10px',
    fontSize: '12px',
  },
  primaryText: {
    fontWeight: '600',
  },
  secondaryText: {
    fontStyle: 'italic',
  },
});
